import { Tooltip } from 'antd';
import { Promotion } from '../../../../stores/promotion';
import { getItemProp } from '../../../../utils';
import style from './styles.module.scss';

const renderItem = (
    record: Promotion,
    type: 'title' | 'subTitle' | 'thumbnail'
) => {
    const enValue = getItemProp(
        record.items,
        'en',
        type === 'thumbnail' ? 'thumbnail' : type
    );

    if (type === 'thumbnail') {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img
                    key="en"
                    src={enValue ?? ''}
                    alt=""
                    className={style.thumbnail}
                />
            </div>
        );
    }

    return (
        <Tooltip title={enValue}>
            <div className={style[type === 'subTitle' ? 'subtitle' : type]}>
                {enValue}
            </div>
        </Tooltip>
    );
};

export default renderItem;
